import React, { Component } from 'react';

// COMPONENTS
import { Typography, Button, CoreIcons } from 'components';
import { Trans } from '@lingui/macro';
import Row from '../../../components/Row';

import * as routes from './../../../settings/_routesSettings';
import { history } from '../../../routers/AppRouter';

class Confirmation extends Component {
  render() {
    return (
      <div className="CheckoutPlans">
        <div className="CheckoutPlans__content">
          <div className="Confirmation">
            <CoreIcons name="Check" fill="#4ac326" height="50px" width="50px" />

            <Row justify="center" margin="2rem 0">
              <Typography align="center" type="subtitle">
                <Trans>Você agendou uma consulta</Trans>{`\n`}
                <Trans>com pedido médico.</Trans>
              </Typography>
            </Row>

            <Row justify="center">
              <Typography align="center">
                Neste caso, confirmaremos a autorização{`\n`}
                junto ao seu plano, que <span>em até 48h</span>{`\n`}
                <span>responderá sobre a liberação de consultas</span>{`\n`}
                baseada neste pedido médico.
              </Typography>
            </Row>

            <Row justify="center" margin="2rem 0">
              <Typography align="center">
                Assim que houver a confirmação,{`\n`}
                avisaremos por e-mail e sms.
              </Typography>
            </Row>

            <div className="YellowBox">
              <Typography align="center" type="subheading2">
                <span>Importante:</span> enquanto aguardamos a aprovação do{`\n`}
                seu convênio, não é possível agendar novas consultas.
              </Typography>
            </div>

            <Button
              text="ver minhas consultas"
              onButtonClick={() => history.push(routes.DASHBOARD_APPOINTMENTS)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Confirmation;